// extracted by mini-css-extract-plugin
export default {"containerError":"ErrorMessage_containerError__AGrmZ","buttonClose":"ErrorMessage_buttonClose__bmDnD","textDescriptionError":"ErrorMessage_textDescriptionError__GrUts"};